import { createContext } from "react";

type MeetingPageContextValueType = {
  sidebarMeetingView?: "overview" | "load-previous-meeting" | number;
  setSidebarMeetingView?: (
    view: "overview" | "load-previous-meeting" | number,
  ) => void;
  onChangeMeetingView?: (
    meetingView: string,
    isReviewMeeting?: boolean | null,
  ) => void;
  isInSidebar: boolean;
  isInExtension: boolean;
  // When set (e.g. the profile 1-on-1 tab embeds the meeting page), the
  // prev/next meeting arrows paginate within the embedder instead of
  // navigating to a new meeting page. `position` is relative to the meeting
  // whose arrow was clicked: "before" = newer (above), "after" = older (below).
  onNavigateToMeeting?: (
    target: { id: number; meetingGroupId: number },
    position: "before" | "after",
  ) => void;
  // Autofocus the default topic input on mount. Disabled when many meetings
  // render at once (the profile 1-on-1 tab) since the focus query is
  // document-wide and would steal focus / scroll the page.
  autoFocusDefaultTopic?: boolean;
  // Animate topic position changes (framer-motion layout). Disabled when
  // meetings stack in a paginated list: inserting one above shifts the topics
  // below, and the layout animation would make them all slide at once.
  animateTopicLayout?: boolean;
};

export const MeetingPageContext = createContext<MeetingPageContextValueType>({
  sidebarMeetingView: undefined,
  setSidebarMeetingView: undefined,
  onChangeMeetingView: undefined,
  isInSidebar: false,
  isInExtension: false,
  onNavigateToMeeting: undefined,
  autoFocusDefaultTopic: undefined,
  animateTopicLayout: undefined,
});
